/* eslint-disable import/prefer-default-export */
// for local UGC microservice testing use:
// https://localhost:44399/api/usergeneratedcontent
const lp = window.lp || {};
const baseURI = lp.globals && lp.globals.userGeneratedContentBaseUrl ? lp.globals.userGeneratedContentBaseUrl : '';

export { baseURI };
